<ids-modal-footer *ngIf="state">
  <button
    idsMainButton
    *ngIf="state.cancelButton"
    variant="secondary"
    (click)="onCancel()"
    [disabled]="shouldDisableCancelButton()"
  >
    {{ state.cancelButton.text }}
  </button>
  <button
    idsMainButton
    *ngIf="state.confirmButton"
    (click)="onConfirm()"
    [disabled]="shouldDisableConfirmButton()"
    [loading]="state.confirmButton.loading"
  >
    {{ state.confirmButton.text }}
  </button>
</ids-modal-footer>
